
jQuery(function($){
	/**
	 * Set cookieBar variables and run function
	 *
	 * https://github.com/kovarp/jquery.cookieBar
	 */
	
	/**
	 * Run functions
	 */
	inifFancybox();
	blockSlider();
  apartamentsMore();
  contactUs();
  goTo();
  scrollToHash();
  siteMenu();
  rwdMenu();
  productsFilter();
  refreshButton();
  showDialog();

  function showDialog() {

	$('.floors__wrapper svg a').on('click', function(event) {
		event.preventDefault();
	});

	$('a[data-flat]').mouseenter(function() {
        var flatId = $(this).data('flat');
        var position = $(this).offset(); // Pobierz pozycję elementu

        // Pozycjonuj div 200px powyżej i 200px w lewo od odnośnika
        $('#' + flatId).css({
            position: 'absolute',
            top: position.top - 250,
            left: position.left - 100,
            display: 'block'
        });
    }).mouseleave(function() {
        var flatId = $(this).data('flat');
        // Ukryj div po krótkim opóźnieniu, aby umożliwić przeniesienie kursora na div
        setTimeout(function() {
            if (!$('#' + flatId).is(':hover')) {
                $('#' + flatId).hide();
            }
        }, 100);
    });

    // Obsługa zdarzeń na divie, aby pozostawał widoczny po najechaniu
    $('div[id^="flat-"]').mouseenter(function() {
        $(this).show();
    }).mouseleave(function() {
        $(this).hide();
    });
  }

  function refreshButton() {

	$("#refreshButton").click(function(event){
		event.preventDefault();
			location.reload();
		});
	}

  function productsFilter() {

	$('#apartaments-filter').on('submit', function (e) {
	e.preventDefault();
	var rooms = $('#rooms').val();
	var floor = $('#floor').val();
	var surface_from = $('#surface_from').val();
	var surface_to = $('#surface_to').val();

	var data = {
		action: 'apartaments_filter',
		rooms: rooms,
		floor: floor,
		surface_from: surface_from,
		surface_to: surface_to,
	};
	
	$.ajax({
	url: '/wp-admin/admin-ajax.php',
	data: data,
	method: 'POST',
	success: function (data) {
	
		data = JSON.parse(data);

		$('.apartaments-list tbody').html(data);
		apartamentsMore();
	},
	cache: false
	});
	
	});
}
  function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1024) {

			$('.menu-item-has-children > a').on('click', function(event) {
				event.preventDefault();
				$(this).parent('li').children('ul').slideToggle(300);
			});

			$(document).on('click', function(event) {
				if (!$(event.target).closest('.phone-main-mobile, .phone-main-mobile article, .phone-main-mobile article a').length) {
					$('.phone-main-mobile article').hide();
					$('.phone-main-mobile').removeClass('active');
				}
			});
			
			$('.phone-main-mobile span').on('click', function(event) {
				event.preventDefault();
				var $parentDiv = $(this).parent('div');
			
				if ($parentDiv.hasClass('active')) {
					$parentDiv.children('article').hide();
					$parentDiv.removeClass('active');
				} else {
					$parentDiv.addClass('active');
					$parentDiv.children('article').show();
				}
			});
		}
	}

  function apartamentsMore() {
		$(".show-more").click(function(event) {
			event.preventDefault();
			$(this).parent('td').parent('tr').children('.description').slideToggle(300);
			$(this).toggleClass('active');
		});
	}

  function contactUs() {
		$('.contact-us').click(function(event) {
			event.preventDefault();
			var houseName = $(this).attr('data-name');
      var rooms = $(this).attr('data-rooms');
			console.log(rooms);
      jQuery('#kontakt input[name="rooms[]"]').each(function() {
        var roomValue = $(this).val();
        // Jeśli wartość pokoju zgadza się z atrybutem data-rooms, zaznacz pole wyboru
        if (rooms === roomValue) {
            $(this).prop('checked', true);
        } else {
            $(this).prop('checked', false); // Odznacz pole wyboru, jeśli nie pasuje
        }
    });
			jQuery('#kontakt textarea').val(houseName+'. ')
		});
	}

  function goTo() {

	$(".go-to").click(function(event) {
		event.preventDefault();
		var href = $(this).attr('href');
		var pos = -200;
		jQuery('html, body').animate({
			scrollTop: jQuery(href).offset().top + pos
			}, 500);
	});

	$(".contact-menu a").click(function(event) {
		event.preventDefault();
		var href = $(this).attr('href');
		var pos = 5;
		jQuery('html, body').animate({
			scrollTop: jQuery(href).offset().top + pos
			}, 500);
	});
	}

  function siteMenu() {
    var window_width = jQuery(window).width();
    
    jQuery(".home .site-header__logo, .home .internal a").click(function(event) {
      event.preventDefault(); 
    
      var href = jQuery(this).attr('href');
      var href = href.substring(1, href.length);
      if(href == '#o-inwestycji') {
        var pos = 10;
      } else {
        var pos = 200;
      }
      
    
      jQuery('html, body').animate({
      scrollTop: jQuery(href).offset().top - pos
      }, 200);
    
      jQuery('body').addClass('clicked');
      if (window_width < 768) {
      jQuery('#hamburger').removeClass('open');
      jQuery('.site-header__navigation').slideUp(400);
      }
    });
    

  jQuery(".page-id-1305 .logo a, .home .internal-en a").click(function(event) {
      event.preventDefault(); 
    
      var href = jQuery(this).attr('href');
      var href = href.substring(1, href.length);
      var pos = 70;
  		var href = href.replace("en/", "");
      console.log(href);
    
      jQuery('html, body').animate({
      scrollTop: jQuery(href).offset().top - pos
      }, 200);
    
      jQuery('body').addClass('clicked');
      if (window_width < 768) {
      jQuery('#hamburger').removeClass('open');
      jQuery('.site-header__navigation ul').slideUp(400);
      }
    });
}

  function scrollToHash() {
    if(window.location.hash) {
      var hash = window.location.hash.substring(1); // Get the hash value without the '#'
      var element = $('#' + hash); // Find the element with the corresponding ID

      
      if('oferta' == hash) {
        var scroll = 200;
      } else if('plan-pietra' == hash) {
		console.log(hash);
        var scroll = 200;
      } else if('mieszkanie' == hash) {
        var scroll = 120;
      } else {
        var scroll = 0;
      }
      
      if(element.length) {
        $('html, body').animate({
          scrollTop: element.offset().top - scroll
        }, 500); 
      }
    }
  }

	function inifFancybox() {
		Fancybox.bind('[data-fancybox]', {
		  Thumbs: false,
			  loop : true,
	
		  afterClose: function(instance, current) {
			var videos = document.querySelectorAll('.inline-movies');
	
			// Loop through all videos with class 'inline-movies' and pause them
			videos.forEach(function(video) {
				video.pause();
			});
		  }
			});
		  }

	function blockSlider() {
		

		

		jQuery('.header-slider-one').owlCarousel({
		  loop:false,
		  margin:0,
		  nav:true,
		  items:1,
		  autoplay:false,
		  autoplayTimeout:4000,
		  autoplaySpeed: 1700,
		  slideSpeed: 1700,
		  navSpeed: 1700,
		  dotsSpeed: 1700,
		  dots: true,
		  singleItem: true,
		  navText: ["<",">"],
      		autoplayHoverPause:true
		  
		});

		jQuery('.header-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
			singleItem: true,
			navText: ["<",">"],
				autoplayHoverPause:true
			
		  });

    jQuery('.gallery-slider').owlCarousel({
		  loop:true,
		  margin:0,
		  nav:true,
		  items:1,
		  autoplay:false,
		  autoplayTimeout:4000,
		  autoplaySpeed: 1700,
		  slideSpeed: 1700,
		  navSpeed: 1700,
		  dotsSpeed: 1700,
		  dots: true,
		  singleItem: true,
		  navText: ["<",">"],
      autoplayHoverPause:true
		  
		});

    
	 }

	
})